module.exports = __webpack_public_path__ + "img/ais-target-heading-n.437a1ce2.svg";